var commentTextareaAutoGrow = function ($item) {
    $item.autoGrow();
}

$(function() {
    var $originForm = $('#commentForm');
    if ($originForm.length == 0) {
        $originForm = $($('.comment-form')[0]);
    }
    $('body').on('submit', '#commentForm, .comment-reply-form, .comment-form', function(event) {
        event.preventDefault();
        var serialize = $(this).serialize();
        var $form = $(this);
        if ($(this).find('textarea').val().length > 0) {
            $form.find('input, textarea').prop('disabled', true);
            $.ajax({
                url: '/comment/post',
                type: 'POST',
                dataType: 'html',
                data: serialize,
            }).done(function(data) {
                if (data && data != '') {
                    $form.find('textarea').val('').trigger('keyup');
                    if ($form.is('.comment-reply-form')) {
                        $form.before(data);
                    } else {
                        var listId = $form.data('id');
                        if (listId != '' && listId != undefined) {
                            var $commentContainer = $('#commentsList-' + listId);
                            $commentContainer.prepend(data);
                        }
                    }
                }
            }).fail(function() {
            }).always(function() {
                $form.find('input, textarea').prop('disabled', false);
            });
        }
    }).on('keydown', '.comment-textarea', function(event) {
        if (event.keyCode == 13 && ! event.shiftKey) {
            event.preventDefault();
            $(this).parents('form').submit();
        }
    }).on('click', '.comment-delete', function(event) {
        event.preventDefault();
        var id = $(this).data('id');
        var $body = $(this).parents('#comment-' + id);
        if ( ! $(this).hasClass('comment-delete-doing')) {
            if ( ! $(this).hasClass('comment-delete-alert') || confirm('Are you sure want to delete this?')) {
                $(this).addClass('comment-delete-doing');
                $.post('/comment/delete', {commentId: id}, function(data, textStatus, xhr) {
                    if (data == true) {
                        $body.fadeOut(400, function() {
                            $(this).remove();
                        });
                    }
                });
            }
        }
    }).on('click', '.comment-reply', function(event) {
        event.preventDefault();
        $body = $(this).parents('.media-body');
        var $form = $body.find('.comment-reply-form');
        if ($originForm.length < 1) {
            location.href = '/auth/login';
        }
        if ($form.length < 1) {
            $('<form class="comment-reply-form" style="display: none;"></form>').html($originForm.html()).append('<input type="hidden" name="parentId" value="' + $(this).data('id')  + '" />').appendTo($body);
            $body.find('.comment-reply-form').fadeIn(100).find('.comment-textarea').autoGrow();
        } else {
            $form.fadeOut(100, function() {
                $(this).remove();
            });
        }
    }).on('click', '.more-comments', function(event) {
        event.preventDefault();
        var $commentMore = $(this).parents('.commentsList').find('.more-comments-loading').fadeIn();
        var id = $(this).data('id');
        var page = $commentMore.data('page');
        var dashboardParent = $(this).parents('.mdl-card__supporting-comments');
        var height = dashboardParent.height();
        if (page == 0 || page == undefined) {
            $commentMore.data('page', 1);
            page = 1;
        }

        var $card = $(this).parents('.mdl-card');
        $(this).remove();
        $.get('/comment/more/' + id + '/' + page + '/' + ($(this).data('simple') != undefined ? 1 : 0), {}, function(data) {
            if (data) {
                $commentMore.data('page', page + 1);
                $commentMore.before(data);

                if (dashboardParent.length > 0) {
                    var addHeight = dashboardParent.height() - height;
                    $card.height($card.height() + addHeight);
                    startWaterFlow($('#image-post-card-posts-container'), '.image-post-card', 1, 10);
                }
            }
            $commentMore.fadeOut();
        });
    }).on('click', '.show-more-comment-without-ajax', function(event) {
        event.preventDefault();
        var dashboardParent = $(this).parents('.mdl-card__supporting-comments');
        var height = dashboardParent.height();
        $(this).parent().children('.media, .more-comments-index').show();
        if (dashboardParent.length > 0) {
            var addHeight = dashboardParent.height() - height;
            var $card = $(this).parents('.mdl-card');
            $card.height(($card.height() + addHeight));
            startWaterFlow($('#image-post-card-posts-container'), '.image-post-card', 1, 10);
        }
        $(this).remove();
    }).on('click', '.watch-liked-peoples', function(event) {
        event.preventDefault();
        var $list = $(this).next('.liked-peoples-list');
        if ($list.is(':hidden')) {
            if ($list.find('li').length == 0 && $(this).data('loading') == undefined) {
                $(this).data('loading', 1);
                var loading = $list.append('<li class="loading"><i class="fa fa-refresh fa-spin"></i></li>').find('.loading'),
                    type = $(this).data('type') == 'favorites' ? 'favorite' : 'like';
                $.ajax({
                    url: '/' + type + '/' + $(this).data('id'),
                    type: 'GET',
                    dataType: 'html',
                    data: {},
                }).done(function(data) {
                    $list.append(data).slideDown().find("[rel='tooltip']").tooltip();
                }).fail(function() {
                }).always(function() {
                    loading.remove();
                });
            }
            $list.slideDown();
            $(this).find('.fa-chevron-down').removeClass('fa-chevron-down').addClass('fa-chevron-up');
        } else {
            $list.slideUp();
            $(this).find('.fa-chevron-up').removeClass('fa-chevron-up').addClass('fa-chevron-down');
        }
    }).on('click', '.js-commentEmojiButton', function(event) {
        var $commentEmojiList = $(this).parents('.comment-form, .comment-reply-form').find('.commentEmojiList');
        event.preventDefault();
        if ($commentEmojiList.html() == '') {
            $commentEmojiList.html($('#commentEmojiList-sample').html());
            $($commentEmojiList.find('.comment-emoji-tab')[0]).trigger('click');
        }
        if ($commentEmojiList.is(':hidden')) {
            $commentEmojiList.show();
        } else {
            $commentEmojiList.hide();
        }
    }).on('click', '.comment-emoji-tab', function(e) {
        e.preventDefault();
        var $c = $(this).parents('.commentEmojiList');
        $c.find('.active').removeClass('active');
        $(this).parent().addClass('active');
        $c.find('.comment-emoji-list').hide();
        $c.find($(this).attr('href')).show();
    }).on('click', '.js-select-emoji-btn', function() {
        var short = $(this).data('shortname');
        var $textarea = $(this).parents('.comment-form, .comment-reply-form').find('.comment-textarea');
        $textarea.val($textarea.val() + ' ' + short).focus();
    }).on('click', '.js-comment-more-open', function(e) {
        e.preventDefault();
        var parent = $(this).parent();
        parent.children('.comment-row').fadeIn();
        if ($(this).data('type') == 'reply') {
            parent.find('.comment-reply').trigger('click');
        }
        $(this).fadeOut('fast', function() {
            $(this).remove();
        });
    });
    var generateEmojiList = function() {
        var tab = [], emojis = [];
        tab.push('<ul class="nav nav-pills">');
        $.each(emojiOneCharDataSet, function(groupIndex, group) {
            tab.push('<li role="presentation"><a class="comment-emoji-tab" href="#emojisGroup-' + groupIndex + '"><i class="fa fa-' + group.icon + '"></i></a></li>');
        });
        tab.push('</ul>');
        tab.push('<hr/>');
        $.each(emojiOneCharDataSet, function(groupIndex, group) {
            emojis.push('<div class="comment-emoji-list" id="emojisGroup-' + groupIndex + '" style="display: none;">');
                $.each(group.icons, function(index, emoji) {
                    emojis.push('<a class="btn btn-default js-select-emoji-btn" data-shortname="' + emoji.shortname + '">' + emojione.shortnameToImage(emoji.shortname)  + '</a>');
                });
            emojis.push('</div>');
        });
        var table = $('<div id="commentEmojiList-sample"></div>').hide().append(tab.join('')).append(emojis.join('')).appendTo('body');
    };
    generateEmojiList();
})